<template>
  <ContactGroupForm :description="description" @submit="onSubmit($event)"></ContactGroupForm>
</template>

<script>
  import ContactGroupService from '../services/contact-group.service';
  import ContactGroupForm from './ContactGroupForm';

  export default {
    name: 'ContactAdd',
    components: {
      ContactGroupForm
    },
    data() {
      return {
        description: ''
      };
    },
    methods: {
      onSubmit(event) {
        ContactGroupService.create(event).then(() => {
          this.$router.push('/contact-group/list');
          this.$showSuccessMessage('Added Contact group');
        });
      }
    }
  };
</script>

<style lang="scss" scoped></style>
